// import { FaUser, FaCog, FaSignOutAlt, FaPuzzlePiece, FaQuestionCircle, FaBook } from "react-icons/fa";
import ProfileToggle from "./ProfileToggle.module.css";
import { logoutUser } from "../../utils/localStorageUtils";
import popupsyle from "../../style/PopUp.module.css";
import { getCompanyDetails, getUserDetails } from "../../utils/auth";
import webSocket from "../../services/onlineSocketService";
import { logOut } from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";
import { deleteToken } from "firebase/messaging";
import { messaging } from "../../firebase/firebase";
import { FaSpinner } from "react-icons/fa";

const ProfileDropdown = ({ show, close, Click }) => {
  const navigate = useNavigate();
  const [imgError, setImgError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  if (!show) return null;
  const handleLogout = async () => {
    setLoading(true);
    try {
      const success = await deleteToken(messaging);
      if (success) {
        await logOut();

        webSocket.disconnect();

        // Disconnect WebSocket
        logoutUser();
        // Clear localStorage/session
        window.location.reload();

        navigate("/login");

        // Wait for logout API to complete
      }
    } catch (error) {
      console.error("Logout API failed", error);
      // Optional: Show error to user or continue
    } finally {
      setLoading(false);
    }
  };
  const BASE_URL = process.env.REACT_APP_API_URL;
  const userDetails = getUserDetails();
  const companyDetails = getCompanyDetails();

  const Open = (data) => {
    Click(data);
    close();
  };
  return (
    <div
      className={popupsyle.popupBackgroundNormal}
      onClick={(e) => e.target === e.currentTarget && close()}
    >
      <div className={ProfileToggle.dropdowncontainer}>
        <div className={ProfileToggle.dropdownmenu}>
          <ul>
            <li>
              <span className={ProfileToggle.profileNameNdImg}>
                <div className={ProfileToggle.profileimage}>
                  {imgError || !userDetails?.emp_pic ? (
                    <FallbackAvatar
                      name={userDetails?.name || "User"}
                      size={45}
                    />
                  ) : (
                    <img
                      src={`${BASE_URL}${userDetails?.emp_pic}`}
                      alt="User Logo"
                      onError={() => setImgError(true)}
                    />
                  )}{" "}
                </div>
                <div>
                  <p
                    className={`${ProfileToggle.profileName} ${ProfileToggle.truncateText}`}
                  >
                    {userDetails.name}
                  </p>
                  <p className={ProfileToggle.profileStatus}>active</p>
                </div>
              </span>
              {/* 👤 Profile */}
            </li>

            <hr />
            <li onClick={() => Open("Profile")}>Profile</li>
            <li onClick={() => Open("ChangePassword")}>Change Password</li>

            <li onClick={() => navigate("/help")}>Help Center</li>
            <hr />

            <li className={ProfileToggle.logout} onClick={handleLogout}>
              {isLoading ? (
                <>
                  <FaSpinner className={ProfileToggle.spinner} />
                  Signing out...
                </>
              ) : (
                <p
                  className={`${ProfileToggle.profileStatus} ${ProfileToggle.truncateText}`}
                  title={companyDetails[0]?.company_name} // full company name on hover
                >
                  {`Sign out of ${companyDetails[0]?.company_name}`}
                </p>
              )}
            </li>
          </ul>
        </div>
        {/* )} */}
      </div>
    </div>
  );
};
export default ProfileDropdown;
